module.exports = __webpack_public_path__ + "static/media/12-4.29b8eb25.mp3";